<template>
  <div>
    <b-alert v-if="erro" show variant="danger">{{ erro }}</b-alert>
    <div class="row">
      <div :class="'col-md-' + col + ' col-sm-12'">
        <div class="form-group mb-2">
          <label class="d-block font-weight-bold">Unidade responsável pelo grupo</label>
          <input class="form-control" type="text" :value="unidade.nome || ''" disabled />
        </div>
      </div>
      <form-select
        v-model="selecionados"
        :grid="col"
        label="Técnicos participantes"
        placeholder="Selecione os técnicos da unidade do grupo"
        :multiple="true"
        :itens="opcoes"
        :loading="loading"
        :disabled="loading || !!erro"
      />
    </div>
    <p v-if="possuiParticipacaoAnterior" class="small text-muted">
      Há participantes cadastrados cujo vínculo atual está indisponível.
      Essas participações serão preservadas até sua retirada explícita.
    </p>
  </div>
</template>

<script>
function normalizarId(id) {
  const numero = Number(id);
  return Number.isSafeInteger(numero) && numero > 0 ? numero : id;
}

export default {
  name: 'SearchTecnicoGrupo',
  model: { prop: 'tecnicos', event: 'change' },
  props: {
    grupoId: { type: [Number, String], default: null },
    tecnicos: { type: Array, default: () => [] },
    col: { type: String, default: '12' },
  },
  data() {
    return {
      unidade: {},
      disponiveis: [],
      cadastrados: [],
      loading: false,
      erro: '',
      sequencia: 0,
    };
  },
  computed: {
    selecionados: {
      get() {
        return Array.isArray(this.tecnicos) ? this.tecnicos.map(normalizarId) : [];
      },
      set(valor) {
        const ids = Array.isArray(valor) ? valor.map(normalizarId) : [];
        this.$emit('update:tecnicos', ids);
        this.$emit('change', ids);
      },
    },
    opcoes() {
      const porId = new Map();
      this.disponiveis.forEach((opcao) => porId.set(String(opcao.id), opcao));

      // Oferecer para nova seleção somente profissionais disponíveis.
      // Uma participação antiga só aparece enquanto continuar selecionada.
      const selecionados = new Set((this.tecnicos || []).map(String));
      this.cadastrados.forEach((opcao) => {
        const chave = String(opcao.id);
        if (selecionados.has(chave) && !porId.has(chave)) {
          porId.set(chave, opcao);
        }
      });

      // Nunca limpar o formulário se um cadastro não puder ser carregado.
      (this.tecnicos || []).forEach((id) => {
        const chave = String(id);
        if (!porId.has(chave)) {
          porId.set(chave, { id: normalizarId(id), value: 'Técnico #' + id + ' (informações indisponíveis)' });
        }
      });

      return Array.from(porId.values());
    },
    possuiParticipacaoAnterior() {
      const ids = new Set((this.tecnicos || []).map(String));
      return this.cadastrados.some((opcao) => !opcao.disponivel && ids.has(String(opcao.id)));
    },
  },
  watch: {
    grupoId() {
      this.carregar();
    },
  },
  mounted() {
    this.carregar();
  },
  beforeDestroy() {
    this.sequencia++;
  },
  methods: {
    async carregar() {
      const requisicao = ++this.sequencia;
      this.loading = true;
      this.erro = '';
      this.unidade = {};
      this.disponiveis = [];
      this.cadastrados = [];

      try {
        const params = this.grupoId ? { grupo_id: this.grupoId } : {};
        const response = await axios.get('api/dashboard/scfv/tecnicos-participantes', { params });
        if (requisicao !== this.sequencia) return;

        const dados = response.data;
        this.unidade = dados.unidade || {};
        this.disponiveis = Array.isArray(dados.tecnicos) ? dados.tecnicos : [];
        this.cadastrados = Array.isArray(dados.cadastrados) ? dados.cadastrados : [];
      } catch (erro) {
        if (requisicao !== this.sequencia) return;
        this.erro = 'Não foi possível carregar os técnicos da unidade do grupo. Tente novamente.';
      } finally {
        if (requisicao === this.sequencia) this.loading = false;
      }
    },
  },
};
</script>